module.exports = __webpack_public_path__ + "static/img/JGArchitecture_DataAgent_image.acb2ca64.png";